@if (isVisible()) {
  <div
    class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 animation-opacity"
    (click)="onBackdropClick()"
    [class.cursor-pointer]="config().allowOutsideClick"
  >
    <div
      animate.enter="enter-modal" animate.leave="leave-modal"
      class="bg-white rounded-lg p-8 max-w-md w-11/12 shadow-2xl animate-in fade-in slide-in-from-top-4 duration-300"
      (click)="$event.stopPropagation()"
    >
      <div class="flex justify-center mb-4">
          <span
            class="w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold"
            [ngClass]="getIconClass()"
          >
            {{ getIcon() }}
          </span>
      </div>
      <h2 class="text-2xl font-bold text-center text-gray-800 mb-2">
        {{ config().title }}
      </h2>
      <p class="text-center text-gray-600 mb-6 leading-relaxed">
        {{ config().message }}
      </p>
      <div class="flex gap-3 justify-center">
        @if (config().showCancel) {
          <button
            class="px-6 py-2 rounded-md font-semibold transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed bg-gray-200 text-gray-700 hover:bg-gray-300 cursor-pointer"
            (click)="cancel()"
            [disabled]="isLoading()"
          >
            {{ config().cancelText || 'Cancelar' }}
          </button>
        }
        @if (true) {
          <button
            class="px-6 py-2 rounded-md font-semibold transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed text-white flex items-center justify-center gap-2 min-w-24 cursor-pointer"
            [ngClass]="getBtnClass()"
            (click)="confirm()"
            [disabled]="isLoading()"
          >
            <span *ngIf="!isLoading()">{{ config().confirmText || 'Aceptar' }}</span>
            <span
              *ngIf="isLoading()"
              class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"
            ></span>
          </button>
        }
      </div>
    </div>
  </div>
}
